/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 1/4/2023
 */


import { Dialog, DialogContent, MenuItem, MenuList } from "@mui/material";
import { useGetAllCatWithSubCatQuery } from "../../Store/Services/CategoryService";

import styles from "./CategoryList.module.css"

const CategoryList = ({ open, onClose, setSelectedCat, selectedCat, setCatName }) => {

    const { data: categories, isSuccess } = useGetAllCatWithSubCatQuery();

    let catList
    if(isSuccess) {
    console.log('cats', categories);
        catList = categories
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth maxWidth="sm">
            <DialogContent>
                ####### cat list #############
                <MenuList>
                    {catList?.map((cat) => (
                        <SubList
                            key={cat.catId}
                            subCat={cat}
                            level={0}
                            setSelectedCat={setSelectedCat}
                            selectedCat={selectedCat}
                            onClose={() => onClose()}
                            setCatName={setCatName}
                        />
                    ))}
                </MenuList>
            </DialogContent>
        </Dialog>
    );
}

const SubList = ({ subCat, level, setSelectedCat, selectedCat, onClose, setCatName }) => {

    let dash = ''

    for (var i=0; i<level; i++){
        dash = dash + ' - '
    }

    const handleItemSelect = (id, name) => {
        setSelectedCat(id)
        setCatName(name)
        onClose()
    }

    return (
        <>
            <MenuItem
                className={selectedCat===subCat.catId ? styles.selected : 'null'}
                onClick={() => handleItemSelect(subCat.catId, subCat.categoryDisplayName)}
                key={subCat.catId}
            >
                {`${dash} ${subCat.categoryDisplayName}`}
            </MenuItem>
            ####### sub list #############

            {subCat.subCategory && Array.isArray(subCat.subCategory) && subCat.subCategory.length!==0
            ? subCat.subCategory.map((node) =>
                <SubList
                    key={node.catId}
                    subCat={node}
                    level={level+1}
                    setSelectedCat={setSelectedCat}
                    selectedCat={selectedCat}
                    onClose={() => onClose()}
                    setCatName={setCatName}
                />)
            : null}
        </>
    )
}

export default CategoryList